import { IssueRptService } from '../services';
import { issueRptConstants } from '../constants';
import {alertActions} from '.';

export const issueRptActions = {
    getAll, 
    loadingData,
    exportData
};

function getAll(obj)
{
    return dispatch =>{
        dispatch(request());
        IssueRptService.fetchIssueRptData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(successExport(data))
        },
        error => {
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.toString()));
        }
        
        );
    };
    function request() { return { type : issueRptConstants.GETALL_REQUEST } }
    function success(datas) { return { type: issueRptConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type: issueRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: issueRptConstants.GETALL_FAILURE, error } }
}

function exportData(obj) {
    return dispatch => {
        dispatch(request());
        IssueRptService.fetchIssueRptData(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type: issueRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: issueRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: issueRptConstants.GETEXPORT_FAILURE, error } }
}

function loadingData(isbool) {
    return {
        type: issueRptConstants.LOADING_REQUEST, isbool
    }
}
